import {
  getAppEnvironment,
  getEnvironmentBadgeEnv,
  getEnvironmentLabel,
} from "../config/app-environment";
import { formatAppVersion } from "../config/app-version";
import { useEffect } from "react";

export function EnvBadge() {
  const appEnv = getAppEnvironment();
  const badgeEnv = getEnvironmentBadgeEnv(appEnv);
  const label = getEnvironmentLabel(appEnv);
  const version = formatAppVersion(
    import.meta.env.VITE_APP_VERSION,
    import.meta.env.VITE_RELEASE_STAGE,
  );

  useEffect(() => {
    document.documentElement.dataset.appEnv = badgeEnv;
  }, [badgeEnv]);

  return (
    <span className="env-badge" data-env={badgeEnv}>
      {label}
      {version === null ? null : ` · ${version}`}
    </span>
  );
}
